import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import {
  buildPreProdContentPath,
  buildReviewPath,
  EditorialReviewEntities,
  EditorialReviewModel,
  FirstContentEntity,
} from 'client/data/models/editorial-review';
import { CorePageParams, getParamsFromVehicle } from 'site-modules/shared/utils/core-page/params';
import { ScorecardEditorialReviewBody } from 'site-modules/core-page/components/scorecard-editorial-review/scorecard-editorial-review-body';

import './scorecard-editorial-review.scss';

export function ScorecardEditorialReviewUI({
  editorialReview,
  vehicle,
  hasRouteYearParam,
  firstContent,
  embeddedModules,
  isUsed,
  isPreprod,
  params,
  showRightColumn,
  showScorecard,
  showHighlights,
  showBottomHr,
  hasTrimsLink,
  showTrimsReview,
}) {
  if (!editorialReview) {
    return null;
  }

  const { reviewLink } = editorialReview;
  const hasRelatedArticles = !!get(firstContent, 'articles.length');
  if (!reviewLink && !hasRelatedArticles) {
    return null;
  }
  const contentColumnSize = showRightColumn ? { xs: 12, lg: 8 } : { xs: 12 };

  const reviewBody = (
    <ScorecardEditorialReviewBody
      params={params}
      vehicle={vehicle}
      embeddedModules={embeddedModules}
      hasRouteYearParam={hasRouteYearParam}
      hasTrimsLink={hasTrimsLink}
      showScorecard={showScorecard}
      showHighlights={showHighlights}
      showTrimsReview={showTrimsReview}
      isPreprod={isPreprod}
      isUsed={isUsed}
    />
  );

  // Show FL/FD content if has no editorial review
  if (!reviewLink) {
    return (
      <Row className="preprod-article">
        <Col {...contentColumnSize} className="px-1 mb-2">
          {reviewBody}
        </Col>
      </Row>
    );
  }

  return (
    <Row className="scorecard-editorial-review">
      <Col {...contentColumnSize} className="px-1">
        {reviewBody}
        {showBottomHr && <hr />}
      </Col>
    </Row>
  );
}

ScorecardEditorialReviewUI.propTypes = {
  params: CorePageParams.isRequired,
  editorialReview: EditorialReviewEntities.EditorialReview,
  firstContent: FirstContentEntity,
  vehicle: PropTypes.shape({
    make: PropTypes.shape({
      name: PropTypes.string,
    }),
    model: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  embeddedModules: PropTypes.shape({
    pricingModule: PropTypes.node,
    rangeAndCostModule: PropTypes.node,
    coreSrpModule: PropTypes.node,
  }),
  hasRouteYearParam: PropTypes.bool,
  isUsed: PropTypes.bool,
  isPreprod: PropTypes.bool,
  showRightColumn: PropTypes.bool,
  showScorecard: PropTypes.bool,
  showHighlights: PropTypes.bool,
  showBottomHr: PropTypes.bool,
  hasTrimsLink: PropTypes.bool,
  showTrimsReview: PropTypes.bool,
};

ScorecardEditorialReviewUI.defaultProps = {
  editorialReview: null,
  reviewAuthor: null,
  firstContent: null,
  vehicle: null,
  embeddedModules: null,
  hasRouteYearParam: false,
  isUsed: false,
  isPreprod: false,
  showRightColumn: true,
  showScorecard: true,
  showHighlights: false,
  showBottomHr: true,
  showTrimsReview: false,
  hasTrimsLink: true,
};

export const ScorecardEditorialReview = connectToModel(ScorecardEditorialReviewUI, {
  editorialReview: bindToPath(({ params }) => buildReviewPath(params), EditorialReviewModel),
  firstContent: bindToPath(
    ({ vehicle }) => buildPreProdContentPath(getParamsFromVehicle(vehicle)),
    EditorialReviewModel
  ),
});
